import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=d2913208&scoped=true&"
import script from "./Music.vue?vue&type=script&lang=js&"
export * from "./Music.vue?vue&type=script&lang=js&"
import style0 from "./Music.vue?vue&type=style&index=0&id=d2913208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2913208",
  null
  
)

export default component.exports